import { useEffect } from "react";
// import { REPORTS_STATS_API } from "../../constants/api";
import { useFirebase } from "../firebase/useFirebase";

export const useDashboard = () => {
  const {
    getDocData: getDashboard,
    data: dashboardData,
    loading,
  } = useFirebase();

  useEffect(() => {
    getDashboard("reports/stats");
  }, []);

  return { dashboardData, loading };
};
